import axios from "axios";

export class CallToActionApi {
  async getCallToAction(params: any = {}) {
    try {
      const urlParams = new URLSearchParams();
      if (
        params.saleOrgCriteriaId !== undefined &&
        params.saleOrgCriteriaId !== null &&
        params.saleOrgCriteriaId !== ""
      ) {
        urlParams.append("saleOrgCriteriaId", String(params.saleOrgCriteriaId));
      }
      if (
        params.activityDate !== undefined &&
        params.activityDate !== null &&
        params.activityDate !== ""
      ) {
        urlParams.append("activityDate", String(params.activityDate));
      }
      const queryString = urlParams.toString();
      const path = `/api/CallToAction/${params.customerCode}${
        queryString ? `?${queryString}` : ""
      }`;
      const res = await axios.get(path);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async getStockByCustomer(params: any = {}) {
    try {
      const urlParams = new URLSearchParams();
      if (
        params.saleOrgCriteriaId !== undefined &&
        params.saleOrgCriteriaId !== null &&
        params.saleOrgCriteriaId !== ""
      ) {
        urlParams.append("saleOrgCriteriaId", String(params.saleOrgCriteriaId));
      }
      if (
        params.activityDate !== undefined &&
        params.activityDate !== null &&
        params.activityDate !== ""
      ) {
        urlParams.append("activityDate", String(params.activityDate));
      }
      if (params.productCodes && Array.isArray(params.productCodes)) {
        params.productCodes.forEach((code: string) =>
          urlParams.append("productCode", code),
        );
      }
      const path = `/api/CallToAction/${params.customerCode}/stockByCustomer?${urlParams.toString()}`;
      const res = await axios.get(path);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async saveCallToActionSuccess(data: {
    customerCode: string;
    callToActionIds: number[];
  }) {
    try {
      console.log("post");
      const path = `/api/CallToAction/SaveCallToActionSuccess`;
      const res = await axios.post(path, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
